import clsx from 'clsx'
import { Check } from 'lucide-react'

interface Step {
  number: number
  title: string
  description: string
}

interface Props {
  currentStep: number
  className?: string
}

const steps: Step[] = [
  {
    number: 1,
    title: 'Validate Metadata',
    description: 'Validate your metadata before proceeding with the submission.',
  },
  {
    number: 2,
    title: 'Upload and Validate Assets',
    description: 'Upload your assets and validate them against our requirements.',
  },
  {
    number: 3,
    title: 'Submission',
    description: 'Review and complete your bulk submission.',
  },
]

const StepIndicator = ({ currentStep, className }: Props) => {
  const isStepComplete = (_step: number) => currentStep >= _step

  return (
    <div
      className={clsx(
        'relative flex justify-between mb-4 w-full border-b pb-2',
        className
      )}
    >
      {steps.map((step) => (
        <div key={step.number} className='flex items-center flex-1 justify-center'>
          <div
            className={clsx(
              'flex items-center justify-center w-8 h-8 rounded-full',
              isStepComplete(step.number)
                ? 'bg-secondary-purple text-white'
                : 'bg-gray-200 text-gray-500'
            )}
          >
            {isStepComplete(step.number) ? <Check /> : step.number}
          </div>
          <div className='ml-3'>
            <p className='text-sm font-medium text-gray-900'>{step.title}</p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default StepIndicator
